import { createContext } from 'react'

import { TOverrideType } from 'utility-tools/module/types'
import { IKycDetailsApiDto } from 'nexchange-service/module/kyc'

interface IKycDetailsApiDtoProviderProps extends IKycDetailsApiDto {}
interface IKycDetailsApiDtoProviderState extends IKycDetailsApiDto {}

type TKycDetailsApiDtoContext = TOverrideType<
    IKycDetailsApiDtoProviderProps,
    IKycDetailsApiDtoProviderState | null
>

const KycDetailsApiDtoProvider = createContext<TKycDetailsApiDtoContext>(null)

export type { IKycDetailsApiDtoProviderState }
export { KycDetailsApiDtoProvider }
